var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-container',{staticClass:"giftcardmain"},[_c('v-row',{staticClass:"justify-center"},[_c('v-col',{attrs:{"lg":"6","md":"8","sm":"10","xs":"12"}},[_c('router-view')],1)],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }